import React from 'react'
import Studentattemptquiz from '../../components/student/attemptquiz'
export default function attemptQuiz() {
  return (
    <div>
        <Studentattemptquiz/>
    </div>
  )
}
